import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const MIN_ZOOM_LEVEL = 9;
const MAX_ZOOM_LEVEL = 14;
const TILESETS = {
  darkmatter: L.tileLayer(
    "https://charlevoix-outfitters-space.tor1.digitaloceanspaces.com/maptiles/{z}/{x}/{y}.png",
    {
      maxZoom: MAX_ZOOM_LEVEL,
      minZoom: MIN_ZOOM_LEVEL,
    }
  ),
};

jQuery(document).ready(function () {
  if (jQuery("#outfitter-map").length) {
    var isMobile = window.innerWidth < 1024;

    let map = L.map("outfitter-map", {
      layers: [TILESETS["darkmatter"]],
      attributionControl: false,
      minZoom: MIN_ZOOM_LEVEL,
      maxZoom: MAX_ZOOM_LEVEL,
      maxBounds: [
        [46.3376, -67.7704],
        [48.5779, -72.952],
      ],
      dragging: !isMobile,
      touchZoom: true,
      scrollWheelZoom: !isMobile,
      doubleClickZoom: true,
      tap: false,
      boxZoom: false,
    }).setView([47.55587, -70.3763], 9);

        /**
     * Enable two-finger dragging on mobile
     */
    if (isMobile && map.dragging) {
      map.dragging.disable();
      
      var mapElement = map.getContainer();
      var touchCount = 0;

      mapElement.addEventListener('touchstart', function(e) {
        touchCount = e.touches.length;
        
        if (touchCount === 2) {
          map.dragging.enable();
        } else {
          map.dragging.disable();
        }
      });

      mapElement.addEventListener('touchend', function(e) {
        touchCount = e.touches.length;
        
        if (touchCount < 2) {
          map.dragging.disable();
        }
      });

      mapElement.addEventListener('touchmove', function(e) {
        if (e.touches.length === 2) {
          e.preventDefault();
        }
      }, { passive: false });
    }

     let attributionControl = L.control
      .attribution({
        prefix:
          '© les contributeurs d\'<a href="" target="_blank">OpenStreetMap</a> | © <a href="" target="_blank">OpenMapTiles</a>',
      })
      .addTo(map);

    var markers = {};
    var activeMarkerId = null;

    var $outfitterBoxes = jQuery('.content-outfitter-box');

    var defaultIcon = L.divIcon({
      className: 'custom-marker-icon',
      html: '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><circle cx="8.23621" cy="8.23621" r="8.23621" transform="matrix(-1 0 0 1 16.4727 0)" fill="#F0F045"/></svg>',
      iconSize: [17, 17],
      iconAnchor: [8, 8],
      popupAnchor: [0, -8]
    });

    var activeIcon = L.divIcon({
      className: 'custom-marker-icon active',
      html: '<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<circle cx="8.23621" cy="8.23621" r="8.23621" transform="matrix(-1 0 0 1 18.9141 2.44238)" fill="#F0F045"/>' +
            '<circle cx="10.6786" cy="10.6786" r="10.1786" transform="matrix(-1 0 0 1 21.3574 0)" stroke="#F0F045" fill="none"/>' +
            '</svg>',
      iconSize: [22, 22],
      iconAnchor: [11, 11],
      popupAnchor: [0, -11]
    });

    function resetAllMarkers() {
  if (activeMarkerId !== null && markers[activeMarkerId]) {
    markers[activeMarkerId].setIcon(defaultIcon);
    activeMarkerId = null;
  }
}

function setActiveMarker(outfitterId) {
  if (activeMarkerId !== null && activeMarkerId !== outfitterId && markers[activeMarkerId]) {
    markers[activeMarkerId].setIcon(defaultIcon);
  }
  
  if (markers[outfitterId]) {
    markers[outfitterId].setIcon(activeIcon);
    activeMarkerId = outfitterId;
  }
}

    /**
     * Create markers if outfitter data is available
     */
    if (typeof outfittersMapData !== 'undefined' && outfittersMapData.length > 0) {
      outfittersMapData.forEach(function (outfitter) {
        if (!outfitter.latitude || !outfitter.longitude) {
          return;
        }

        var popupContent = '<a href="' + outfitter.permalink + '" class="group"><div class="outfitter-popup"><div class="flex flex-col px-3.5 justify-center">' +
          '<h3 class="text-text-primary-dark text-lg no-underline my-0! group-hover:underline! decoration-cBlue-500! transition-all duration-300">' + outfitter.title + '</h3>';

        if (outfitter.sector) {
              popupContent += '<div class="text-text-primary-dark/90 font-light leading-6 tracking-paragraph flex items-center gap-1">' +
              '<svg class="w-4 h-4 shrink-0 text-text-primary-dark/90" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">' +
                '<path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />' +
              '</svg>' +
              '<span>' + outfitter.sector + '</span>' +
              '</div>';
        }

        popupContent += '</div>';

        if (outfitter.image) {
          popupContent += '<img src="' + outfitter.image_url + '" alt="' + outfitter.title + '" class="w-1/3 object-cover">';
        }

        popupContent += '</div></a>';

        var marker = L.marker([parseFloat(outfitter.longitude), parseFloat(outfitter.latitude)], {
          icon: defaultIcon
        }).addTo(map);

        marker.bindPopup(popupContent);
        markers[outfitter.id] = marker;

        marker.on('click', function () {

          if (activeMarkerId === outfitter.id) {
                resetAllMarkers();
                } else {
                setActiveMarker(outfitter.id);
                }
 
          if (isMobile) {
            goToOutfitterSlide(outfitter.id);
          } else {
            highlightOutfitter(outfitter.id);
          }
        });
      });
    }

    /**
     * Handle click on map trigger button
     */
    $outfitterBoxes.on('click', '.outfitter-map-trigger', function (e) {
      e.preventDefault();
      var outfitterId = jQuery(this).data('outfitter-id');

      if (isMobile) {
        var $mapContainer = jQuery('#outfitter-map');
        if ($mapContainer.length) {
          jQuery('html, body').animate({
            scrollTop: $mapContainer.offset().top - 20
          }, 500);
        }
      }

      if (markers[outfitterId]) {
        var marker = markers[outfitterId];
        setActiveMarker(outfitterId);
        map.setView(marker.getLatLng(), 14);
        marker.openPopup();
      }
    });

    /**
     * Go to the slider slide corresponding to the outfitter
     *
     * @param {number} outfitterId - The ID of the outfitter
     */
    function goToOutfitterSlide(outfitterId) {
      if (!isMobile) {
        return;
      }

      var $slider = jQuery('.listing-outfitters .swiper-wrapper');
      
      if ($slider.length) {
        var slideIndex = -1;
        
        $slider.children().each(function(index) {
          
          if (jQuery(this).data('outfitter-id') == outfitterId) {
            var orderValue = jQuery(this).css('order');
            slideIndex = parseInt(orderValue) - 1;
            return false; // Break the loop
          }
        });
        
        if (slideIndex >= 0) {
          jQuery(document).trigger('goToOutfitterSlide', [slideIndex]);
        }
      }
    }

    /**
     * Highlight and scroll to outfitter box
     *
     * @param {number} outfitterId The ID of the outfitter
     */
    function highlightOutfitter(outfitterId) {
      console.log('Highlighting outfitter box for ID:', outfitterId);
      var $targetBox = jQuery('.content-outfitter-box[data-outfitter-id="' + outfitterId + '"]');

      if ($targetBox.length) {

        var $scrollContainer = $targetBox.closest('.listing-outfitters ');

        if ($scrollContainer.length) {
        var containerScrollTop = $scrollContainer.scrollTop();
        var containerOffsetTop = $scrollContainer.offset().top;
        var targetOffsetTop = $targetBox.offset().top;
        
        // Calculate the scroll position needed
        var scrollTop = containerScrollTop + (targetOffsetTop - containerOffsetTop) - 20;
                  $scrollContainer.animate({ scrollTop: scrollTop }, 500);
          }
      }
    }
  }
});
